/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Grid } from '@material-ui/core';
import LazyLoad from 'react-lazyload';
import { useQuery } from '@apollo/react-hooks';
import { string, object } from 'prop-types';
import CustomCarousel from '../../GraphqlCommonComponents/TrendingProducts/Partials/CustomCarousel';
import findCategoryPageByUrl from '../../../../gql/queries/findCategoryPageByURL';

let trendingGiftsLength = 0;

const getSlidesLength = (length) => trendingGiftsLength > length ? length : trendingGiftsLength; {/* eslint-disable-line */}

const getSliderResponsive = ({ breakpoint, length, settings = {} }) => ({
    breakpoint,
    settings: {
        slidesToShow: getSlidesLength(length),
        slidesToScroll: getSlidesLength(length),
        ...settings,
    },
});

const getSliderSettings = (giftsLength) => {
    trendingGiftsLength = giftsLength;
    return {
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: getSlidesLength(5),
        slidesToScroll: getSlidesLength(5),
        responsive: [{
            breakpoint: 1024, length: 4,
        },
        {
            breakpoint: 786, length: 3,
        },
        {
            breakpoint: 480,
            length: 2,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false,
                dots: true,
            },
        },
        ].map(getSliderResponsive),
    };
};

const BGSSlider = ({ code, brand }) => {
    const PRODUCT_QUERY = findCategoryPageByUrl(brand.domain, code, 'standard_collections', '', '', '', 'USD', 15);
    const { loading, data } = useQuery(PRODUCT_QUERY);
    const trendingGifts = data?.findCategoryPageByUrl?.category?.products;

    if (loading) return 'Loading...';

    trendingGiftsLength = Array.isArray(trendingGifts) && trendingGifts.length;
    if (!trendingGiftsLength) return null;

    const carouselData = {
        carousel_settings: getSliderSettings(trendingGiftsLength),
        isBGSSlider: true,
        withPrice: '0',
        isCategory: false,
        data: trendingGifts || [],
    };

    return (
        <Grid item className="relative" xs={12}>
            <div className="sliderTitle">
                <h2>Trending Gifts</h2>
            </div>
            <LazyLoad>
                <CustomCarousel {...carouselData} /> {/* eslint-disable-line */}
            </LazyLoad>
        </Grid>
    );
};

BGSSlider.propTypes = {
    code: string.isRequired,
    brand: object.isRequired,
};

export default BGSSlider;
